import { render, staticRenderFns } from "./AllowanceApprovalList.vue?vue&type=template&id=789a4e26&scoped=true"
import script from "./AllowanceApprovalList.vue?vue&type=script&lang=js"
export * from "./AllowanceApprovalList.vue?vue&type=script&lang=js"
import style0 from "./AllowanceApprovalList.vue?vue&type=style&index=0&id=789a4e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a4e26",
  null
  
)

export default component.exports